import { render } from "./Mcilayout.vue?vue&type=template&id=51830cda"
import script from "./Mcilayout.vue?vue&type=script&lang=js"
export * from "./Mcilayout.vue?vue&type=script&lang=js"

import "./Mcilayout.vue?vue&type=style&index=0&id=51830cda&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__